import React from 'react';
import './About.css';

const About: React.FC = () => {
  return (
    <section className="about-section">
      <div className="about-container">
        <h2 className="section-title">About Me</h2>
        <div className="about-content">
          <div className="about-text">
            <p>
              Hi, I'm Adem, a passionate Full Stack Developer with a love for creating 
              efficient and user-friendly web applications. I specialize in modern web 
              technologies and enjoy solving complex problems through clean code.
            </p>
            <div className="skills-section">
              <h3>My Skills</h3>
              <div className="skills-grid">
                <div className="skill-category">
                  <h4>Frontend</h4>
                  <ul>
                    <li>React.js</li>
                    <li>TypeScript</li>
                    <li>HTML5/CSS3</li>
                    <li>JavaScript (ES6+)</li>
                  </ul>
                </div>
                <div className="skill-category">
                  <h4>Backend</h4>
                  <ul>
                    <li>Node.js</li>
                    <li>Express.js</li>
                    <li>MongoDB</li>
                    <li>RESTful APIs</li>
                  </ul>
                </div>
                <div className="skill-category">
                  <h4>Tools & Others</h4>
                  <ul>
                    <li>Git</li>
                    <li>Docker</li>
                    <li>AWS</li>
                    <li>Agile/Scrum</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About; 